<template>
  <div class="wizard-step-content wizard-step-zoom">
    <ul class="wizard-step-content__group-list u-reset">
      <li class="wizard-step-content__group">
        <h2 class="u-reset wizard-step-content__sub-title">
          {{ $t('wizard_step.zoom.adjust_zoom_title') }}
        </h2>

        <zoom-adjuster :zoom="mapConfig.zoom" @update="onUpdate" />
      </li>
      <li class="wizard-step-content__group">
        <h2 class="u-reset wizard-step-content__sub-title">
          {{ $t('wizard_step.zoom.reset_zoom_title') }}
        </h2>

        <zoom-resetter :zoom="mapConfig.zoom" @update="onUpdate" />
      </li>
    </ul>
  </div>
</template>

<script>
  import { throttle } from 'lodash-es'
  import { mapActions } from 'vuex'
  import ZoomAdjuster from '@/components/zoom-adjuster/zoom-adjuster'
  import ZoomResetter from '@/components/zoom-resetter/zoom-resetter'

  export default {
    components: { ZoomResetter, ZoomAdjuster },
    props: {
      mapConfig: {
        type: Object,
        required: true,
      },
    },
    methods: {
      ...mapActions('world-map', ['setMapConfig']),
      onUpdate(zoom) {
        this.throttledSetZoom(this.mapConfig, zoom)
      },
      setZoom(config, zoom) {
        this.setMapConfig({ ...config, zoom })
      },
      throttledSetZoom: throttle(function (config, zoom) {
        this.setZoom(config, zoom)
      }, 40),
    },
  }
</script>

<style lang="scss" src="./_wizard-step-zoom.scss" />
